import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "types",
  initialState: {
    list: [],
  },
  reducers: {
    // action => action handler
    typesReceived: (types, action) => {
      types.list = action.payload;
    },
  },
});

export const { typesReceived } = slice.actions;

export const getTypes = () =>
  apiCallBegan({
    url: "/types",
    method: "get",
    onSuccess: typesReceived.type,
    //   onStart: bugsRequested.type,
    //   onError: bugsRequestFailed.type,
  });

export default slice.reducer;
